import constants from 'Constants';

export const GRID_PARAMETERS_MODEL_HIDDEN_OPERATION = [
        {
            name: '_fixedValue',
            index: '_fixedValue',
            editable: false,
            hidden:true
        },
        {
            name: '_id',
            index: '_id',
            editable: false,
            hidden:true
        },
        {
            name: '_isFixed',
            index: '_isFixed',
            editable: false,
            hidden:true
        },
        {
            name: '_name',
            index: '_name',
            editable:true
        },
        {
            name:'_operation',
            index:'_operation',
            edittype:'select',
            formatter:'select',
            editoptions:{value:"0:=;1:<;2:>;3:<=;4:>=;5:<>;6:LIKE"},
            editable:true,
            hidden:true
        },
        {
            name: '_value',
            index: '_value',
            editable:true
        }
];

export const GRID_PARAMETERS_MODEL_REST = [
    {
        name: '_fixedValue',
        index: '_fixedValue',
        editable: false,
        hidden:true
    },
    {
        name: '_id',
        index: '_id',
        editable: false,
        hidden:true
    },
    {
        name: '_isFixed',
        index: '_isFixed',
        editable: false,
        hidden:true
    },
    {
        name: '_name',
        index: '_name',
        editable:true
    },
    {
        name:'_operation',
        index:'_operation',
        edittype:'select',
        formatter:'select',
        editoptions:{value:"0:=;1:<;2:>;3:<=;4:>=;5:<>;6:LIKE"},
        editable:true,
        hidden:true
    },
    {
        name: '_value',
        index: '_value',
        hidden:true,
        editable:false
    },
    {
        name: '_path',
        index: '_path',
        editable: true
    },
    {

        name: '_placement',
        index: '_placement',
        editable: true,
        // cellEdit: true,
        edittype: 'select',
        formatter: 'select',
        editoptions: {
            value: "path:Path;body:Body;header:Header;pathbody:Path & Body;querystring:Query String",
            dataEvents: [
                {
                    type: 'change',
                    fn: function (e) {
                        let grid = $(constants.CONNECTION_REST_SEND_CONTAINER);
                        let id = grid.getGridParam('selrow');
                        let disableCheckbox = true;                        

                        if (e.target.value !== "body" && e.target.value !== "pathbody"){                            
                            grid.setCell(id, "_dataType", " ");
                            grid.setCell(id, "_isNullable", "false");
                        }else{
                            if (e.target.value === "pathbody"){
                                grid.setCell(id, "_isNullable", "false");
                            }else{
                                 disableCheckbox = false;
                            }

                            let row = grid.getRowData(id);
                            let dataType = row._dataType.trim();

                            if(dataType === ""){
                                grid.setCell(id, "_dataType", "System.String");
                            }
                        }

                        $(e.target).closest('tr').find('input[type="checkbox"]').prop('disabled', disableCheckbox);
                    }
                }
            ]
        }
    },
    {
        name: '_dataType',
        index: '_dataType',
        editable: function (options) {
            var item = $(this).jqGrid("getLocalRow", options.rowid);  
            if (item._placement === "body" || item._placement === "pathbody"){
                return true;
            }
            item._dataType = "";
            $(this).jqGrid("setRowData", options.rowid, item);
            return false;
        },
        cellEdit: true,
        edittype: 'select',
        formatter: 'select',
        editoptions: {
            value: "System.String:String;System.Byte:File"
        },
        formatoptions: {
            value: "System.String:String;System.Int32:Integer;System.Boolean:Boolean;System.Byte:File;null:Null"
        }
    },
    {
        name: '_isNullable',
        index: '_isNullable',
        editable: function (options) {
            var item = $(this).jqGrid("getLocalRow", options.rowid);  
            if (item._placement === "body"){
                return true;
            }
            item._isNullable = false;
            $(this).jqGrid("setRowData", options.rowid, item);
            return false;
        },
        cellEdit: true,
        edittype: 'checkbox',
        formatter: function(cellvalue, options, rowObject) {
            let disabled = '';
            if(rowObject._placement !== 'body'){
                disabled = 'disabled="disabled"';                
            }
            
            let checked = (cellvalue === 'true' && disabled === '') ? 'checked="checked"' : '';

            return '<input type="checkbox" ' + checked + ' ' + disabled + ' />';
        },
        editoptions: {
            value: "true:false"
        },
        formatoptions: {
            disabled: false
        },
        align: 'center'
    }
];

export const GRID_PARAMETERS_MODEL_SHOWN_OPERATION = [
    {
        name: '_fixedValue',
        index: '_fixedValue',
        editable: false,
        hidden:true
    },
    {
        name: '_id',
        index: '_id',
        editable: false,
        hidden:true
    },
    {
        name: '_isFixed',
        index: '_isFixed',
        editable: false,
        hidden:true
    },
    {
        name: '_name',
        index: '_name',
        editable:false
    },
    {
        name:'_operation',
        index:'_operation',
        edittype:'select',
        formatter:'select',
        editoptions:{value:"0:=;1:<;2:>;3:<=;4:>=;5:<>;6:LIKE"},
        editable:true,
        hidden:false
    },
    {
        name: '_value',
        index: '_value',
        editable:false
    }
];
export const GRID_PARAMETERS_MODEL_TEST_ACTION = [
    {
        name: '_fixedValue',
        index: '_fixedValue',
        editable: false,
        hidden:true
    },
    {
        name: '_id',
        index: '_id',
        editable: false,
        hidden:true
    },
    {
        name: '_isFixed',
        index: '_isFixed',
        editable: false,
        hidden:true
    },
    {
        name: '_name',
        index: '_name',
        editable:false,
        classes: 'fix-input-width'
    },
    {
        name:'_operation',
        index:'_operation',
        edittype:'select',
        formatter:'select',
        editoptions:{value:"0:=;1:<;2:>;3:<=;4:>=;5:<>;6:LIKE"},
        editable:false,
        hidden:true,
        align: 'center'
    },
    {
        name: '_value',
        index: '_value',
        editable:true
    }
];
export const GRID_PARAMETERS_MODEL_TEST_ACTION_HEADERS=['Fixed','Id','IsFixed','Name','','Value'];

export const GRID_DATABASE_PARAMETER_HEADERS=['Fixed','Id','IsFixed','Name','','Database Table Column'];

export const GRID_DATABASE_STORE_PROCEDURE_PARAMETER_HEADERS=['Fixed','Id','IsFixed','Name','','Procedure Parameter Name'];

export const GRID_DIRECTORY_SERVICES_PARAMETER_HEADERS=['Fixed','Id','IsFixed','Name','','Attribute Name'];

export const GRID_WEB_SERVICES_PARAMETER_HEADERS=['Fixed','Id','IsFixed','Name','','Service Parameter Name'];
export const GRID_WEB_SERVICES_PARAMETER_HEADERS_XPATH=['Fixed','Id','IsFixed','Name','','XPath'];
export const GRID_REST_SERVICES_PARAMETER_HEADERS=['Fixed','Id','IsFixed','Name','','Value','Service Parameter Name', 'Placement', 'Data Type', 'Is Nullable?'];

export const GRID_FORMS_PARAMETERS_MODEL_SHOWN_OPERATION = [
    {
        name: '_fixedValue',
        index: '_fixedValue',
        editable: false,
        hidden:true
    },
    {
        name: '_id',
        index: '_id',
        editable: false,
        hidden:true
    },
    {
        name: '_isFixed',
        index: '_isFixed',
        editable: false,
        hidden:true
    },
    {
        name: '_name',
        index: '_name',
        editable:true
    },
    {
        name:'_operation',
        index:'_operation',
        edittype:'select',
        formatter:'select',
        editoptions:{value: "0:=;1:<;2:>;3:<=;4:>=;5:<>;6:LIKE"},
        editable:true,
        hidden:false
    },
    {
        name: '_value',
        index: '_value',
        formatter: function (cellvalue, options, rowObject) {
            return rowObject['displayName'] || cellvalue;
        },
        editable: false
    }
];
export const GRID_FORMS_PARAMETERS_MODEL_HIDDEN_OPERATION = [
    {
        name: '_fixedValue',
        index: '_fixedValue',
        editable: false,
        hidden:true
    },
    {
        name: '_id',
        index: '_id',
        editable: false,
        hidden:true
    },
    {
        name: '_isFixed',
        index: '_isFixed',
        editable: false,
        hidden:true
    },
    {
        name: '_name',
        index: '_name',
        editable:true
    },
    {
        name:'_operation',
        index:'_operation',
        edittype:'select',
        formatter:'select',
        editoptions:{value:"0:=;1:<;2:>;3:<=;4:>=;5:<>;6:LIKE"},
        editable:true,
        hidden:true
    },
    {
        name: '_value',
        index: '_value',
        formatter: function (cellvalue, options, rowObject) {
            return rowObject['displayName'] || cellvalue;
        },
        editable: false
    }
];

export const GRID_FORMS_PARAMETER_HEADERS=['Fixed','Id','IsFixed','Name','','Field'];
export const GRID_GOOGLE_PARAMETER_HEADERS_SEND=['Fixed','Id','IsFixed','Name','','Sheet Column'];
export const GRID_GOOGLE_PARAMETER_HEADERS_RETURN=['Fixed','Id','IsFixed','Name','','Sheet Column'];
export const GRID_TEXT_PARAMETER_HEADERS=['Fixed','Id','IsFixed','Name','','CSV Column'];
export const GRID_VECTORDB_PARAMETER_HEADERS=['Fixed','Id','IsFixed','Name','','Value'];
export const GRID_RESULTS_HEADERS=['Parameter 1'];
export const GRID_RESULTS_MODEL = [
    {
        name: '_value',
        index: '_value',
        editable:false
    }
];

